// src/calculators/notice.js — калкулатор „Предизвестие и прекратяване":
// срок и дати по чл. 326/335, цена на неспазено предизвестие (чл. 220),
// обезщетение по чл. 221 и прекратяване срещу обезщетение (чл. 331).
//
// Тук е САМО екранът; цялата нормативна сметка е в services/severance.js
// (обща за тестовете и панела). Нищо не се записва в базата.
//
// Поука от Фаза 1: всяка секция смята в собствен try — непопълнено поле в
// една не бива да скрива резултатите на другите; липсващото се казва с
// подсказка, не с празен екран.

import { el, clear, field, input, row } from '../shared/dom.js';
import { dateInput } from '../shared/dates.js';
// Правното основание (задача 6/6) — цитатите са сверени в lex.bg.
import { withLaw, hintify } from './law.js';
import {
  noticePeriod, calc220, calc221_1, calc221_2, calc331,
} from '../../services/severance.js';

// Запетая като цялата система („540,00 €"); знакът € идва от повикващите.
const f2 = (x) => (Math.round((Number(x) || 0) * 100) / 100).toFixed(2).replace('.', ',');
const okDate = (s) => /^\d{4}-\d{2}-\d{2}$/.test(s || '');
const bgDate = (iso) => String(iso || '').slice(0, 10).split('-').reverse().join('.');
const MONTHS = ['януари', 'февруари', 'март', 'април', 'май', 'юни',
  'юли', 'август', 'септември', 'октомври', 'ноември', 'декември'];

// Местна дата, НЕ toISOString() — то дава UTC и около полунощ връща
// вчерашния ден (известен капан в системата).
function localToday() {
  const d = new Date();
  const p = (n) => String(n).padStart(2, '0');
  return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate());
}

function monthSelect(value) {
  // Първата опция е празна — иначе браузърът тихо избира „януари" (поука
  // от прегледа на Фаза 1).
  return el('select', {},
    el('option', { value: '', text: '— избери —' }),
    ...MONTHS.map((name, i) =>
      el('option', { value: i + 1, text: name, selected: i + 1 === Number(value) })));
}
function numInput(attrs) {
  return input(Object.assign({ type: 'number', step: '0.01', min: '0' }, attrs));
}

export function buildNoticeCalc() {
  // ---- Секция 1: срок и дати ----
  const servedI = dateInput('');
  const unitSel = el('select', {},
    el('option', { value: 'days', text: 'дни (календарни)' }),
    el('option', { value: 'months', text: 'месеци' }));
  const countI = numInput({ step: '1', value: 30 });
  const contractEndI = dateInput('');
  const todayI = dateInput(localToday());
  const outPeriod = el('div', { class: 'calc-result' });

  // ---- Обща база за чл. 220 и чл. 221 (чл. 228, ал. 1) ----
  const baseI = numInput({ placeholder: '0.00' });
  const baseMonthSel = monthSelect('');
  const baseYearI = numInput({ step: '1', placeholder: 'гггг' });

  // ---- Секция 2: чл. 220 ----
  const nUnitSel = el('select', {},
    el('option', { value: 'months', text: 'цели месеци' }),
    el('option', { value: 'workDays', text: 'работни дни' }));
  const nCountI = numInput({ step: '1', placeholder: '0' });
  const out220 = el('div', { class: 'calc-result' });

  // ---- Секция 3: чл. 221 ----
  const alSel = el('select', {},
    el('option', { value: '1', text: 'ал. 1 — работникът ПОЛУЧАВА (чл. 327, ал. 1, т. 2, 3, 3а)' }),
    el('option', { value: '2', text: 'ал. 2 — работникът ДЪЛЖИ (дисциплинарно уволнение)' }),
    el('option', { value: '3', text: 'ал. 3 — работникът ДЪЛЖИ (чл. 330, ал. 1 — осъждане)' }));
  const kindSel = el('select', {},
    el('option', { value: 'indefinite', text: 'безсрочен договор (БТВ за срока на предизвестието)' }),
    el('option', { value: 'fixed', text: 'срочен договор (действителни вреди, чл. 221, ал. 4)' }));
  const c221UnitSel = el('select', {},
    el('option', { value: 'days', text: 'дни' }),
    el('option', { value: 'months', text: 'месеци' }));
  const c221CountI = numInput({ step: '1', value: 30 });
  const c221TermI = dateInput('');
  const c221ContractEndI = dateInput('');
  const c221DaysI = numInput({ step: '1', placeholder: '0' });
  const out221 = el('div', { class: 'calc-result' });
  const boxIndef = el('div', {},
    row(field('Срок на предизвестието — мярка (чл. 221)', c221UnitSel, { size: 'm' }),
      field('Срок на предизвестието — брой (чл. 221)', c221CountI, { size: 's' })));
  const boxFixed = el('div', {},
    row(field('Дата на прекратяване (чл. 221)', c221TermI, { size: 's' }),
      field('Краен срок на договора (чл. 221)', c221ContractEndI, { size: 's' }),
      field('Работни дни на вредите (без работа / без работник)', c221DaysI, { size: 's' })));

  // ---- Секция 4: чл. 331 ----
  const lastGrossI = numInput({ placeholder: '0.00' });
  const multI = numInput({ step: '1', value: 4 });
  const termI331 = dateInput('');
  const out331 = el('div', { class: 'calc-result' });

  function line(label, value, big) {
    return el('div', { class: 'calc-line' + (big ? ' big' : '') },
      el('span', { text: label }), el('span', { text: value }));
  }
  function warnLine(text) { return el('div', { class: 'sev-warn', text }); }
  function noteList(box, notes) {
    notes.forEach((n) => box.appendChild(el('div', { class: 'calc-note', text: n })));
  }
  function hint(box, text) { box.appendChild(el('div', { class: 'calc-note', text })); }

  function recompute() {
    const baseMonth = { year: Number(baseYearI.value) || 0, month: Number(baseMonthSel.value) || 0 };
    const baseMonthOk = baseMonth.year > 0 && baseMonth.month > 0;
    const mb = Number(baseI.value) || 0;

    // ---- 1) Срок и дати ----
    clear(outPeriod);
    try {
      const served = servedI.dataset.iso || '';
      const cnt = Number(countI.value) || 0;
      // Празен брой дава „изтичане" в деня на връчването — по-добре подсказка,
      // отколкото безсмислени дати (находка от прегледа).
      if (okDate(served) && cnt > 0) {
        const opts = { servedOn: served };
        if (unitSel.value === 'months') opts.noticeMonths = cnt; else opts.noticeDays = cnt;
        if (okDate(contractEndI.dataset.iso)) opts.contractEndDate = contractEndI.dataset.iso;
        if (okDate(todayI.dataset.iso)) opts.today = todayI.dataset.iso;
        const p = noticePeriod(opts);
        p.warnings.forEach((w) => outPeriod.appendChild(warnLine(w)));
        outPeriod.appendChild(line('Срокът тече от', bgDate(p.startsOn)));
        outPeriod.appendChild(line('Изтича на', bgDate(p.expiresOn)));
        outPeriod.appendChild(line('Дата на прекратяване (чл. 335, ал. 2)', bgDate(p.terminationDate), true));
        if (p.remainingCalendarDays != null) {
          outPeriod.appendChild(line('Оставащи дни към „днес"',
            p.remainingCalendarDays + ' календарни / ' + p.remainingWorkDays + ' работни'));
        }
        noteList(outPeriod, p.notes);
      } else if (okDate(served)) {
        hint(outPeriod, 'Въведете „Срок — брой" (поне 1), за да се сметнат датите.');
      } else {
        hint(outPeriod, 'Въведете датата на връчване, за да се сметнат сроковете.');
      }
    } catch (e) {
      outPeriod.appendChild(warnLine('Проверете датите: ' + e.message));
    }

    // ---- 2) Чл. 220 ----
    clear(out220);
    try {
      const n = Number(nCountI.value) || 0;
      if (mb > 0 && n > 0) {
        if (nUnitSel.value === 'months' || baseMonthOk) {
          const unserved = nUnitSel.value === 'months' ? { months: n } : { workDays: n };
          const r = calc220({ monthlyBase: mb, baseMonth: baseMonthOk ? baseMonth : null, noticeUnserved: unserved });
          if (r.daily != null) out220.appendChild(line('Среднодневна ставка', f2(r.daily) + ' €/ден'));
          out220.appendChild(line('Бруто', f2(r.gross) + ' €'));
          out220.appendChild(line('Данък 10%', f2(r.tax) + ' €'));
          out220.appendChild(line('Нето', f2(r.net) + ' €', true));
          noteList(out220, r.notes);
        } else {
          hint(out220, 'За неспазена част в РАБОТНИ ДНИ попълнете „Месец на базата" и „Година на базата".');
        }
      } else {
        hint(out220, 'Попълнете месечната база и неспазената част от предизвестието.');
      }
    } catch (e) {
      out220.appendChild(warnLine('Проверете входа: ' + e.message));
    }

    // ---- 3) Чл. 221 ----
    clear(out221);
    boxIndef.style.display = kindSel.value === 'indefinite' ? '' : 'none';
    boxFixed.style.display = kindSel.value === 'fixed' ? '' : 'none';
    try {
      const indefinite = kindSel.value === 'indefinite';
      const opts = { monthlyBase: mb, baseMonth: baseMonthOk ? baseMonth : null, indefinite };
      let ready = mb > 0;
      if (indefinite) {
        const cnt = Number(c221CountI.value) || 0;
        if (c221UnitSel.value === 'months') opts.noticeMonths = cnt; else opts.noticeDays = cnt;
        ready = ready && cnt > 0;
      } else {
        opts.terminationDate = okDate(c221TermI.dataset.iso) ? c221TermI.dataset.iso : '';
        opts.damages = {
          daysWithoutWork: Number(c221DaysI.value) || 0,
          contractEndDate: okDate(c221ContractEndI.dataset.iso) ? c221ContractEndI.dataset.iso : null,
        };
        ready = ready && baseMonthOk && Number(c221DaysI.value) > 0;
      }
      if (ready) {
        const al = alSel.value;
        opts.basis = al === '3' ? 'conviction' : 'discipline';
        const r = al === '1' ? calc221_1(opts) : calc221_2(opts);
        if (r.daily != null) out221.appendChild(line('Среднодневна ставка', f2(r.daily) + ' €/ден'));
        if (r.days != null) out221.appendChild(line('Зачетени работни дни', String(r.days)));
        out221.appendChild(line(r.direction === 'employee-owes'
          ? 'РАБОТНИКЪТ дължи на работодателя'
          : 'Работодателят дължи на работника', f2(r.gross) + ' €', true));
        if (r.direction === 'employee-receives') {
          out221.appendChild(line('Данък 10%', f2(r.tax) + ' €'));
          out221.appendChild(line('Нето за получаване', f2(r.net) + ' €'));
        }
        noteList(out221, r.notes);
      } else if (mb <= 0) {
        hint(out221, 'Попълнете месечната база (чл. 228, ал. 1) най-горе.');
      } else if (indefinite) {
        // Секцията не бива да остава празна — това беше точно състоянието
        // след превключване на вида договор (находка от прегледа).
        hint(out221, 'Въведете „Срок на предизвестието — брой" (поне 1).');
      } else if (!baseMonthOk) {
        hint(out221, 'За срочен договор попълнете „Месец на базата" и „Година на базата" — вредите се смятат по среднодневната ставка.');
      } else {
        hint(out221, 'Въведете „Работни дни на вредите" (поне 1).');
      }
    } catch (e) {
      out221.appendChild(warnLine('Проверете входа: ' + e.message));
    }

    // ---- 4) Чл. 331 ----
    clear(out331);
    try {
      const lg = Number(lastGrossI.value) || 0;
      if (lg > 0) {
        // Суровата стойност отива в сервиза: празно/0 значи „няма уговорка"
        // (законовият размер с бележка), не тиха уговорка за 4.
        const r = calc331({
          lastMonthlyGross: lg,
          agreedMultiplier: multI.value,
          terminationDate: okDate(termI331.dataset.iso) ? termI331.dataset.iso : '',
        });
        r.warnings.forEach((w) => out331.appendChild(warnLine(w)));
        out331.appendChild(line('Бруто', f2(r.gross) + ' €'));
        out331.appendChild(line('Данък 10%', f2(r.tax) + ' €'));
        out331.appendChild(line('Нето', f2(r.net) + ' €', true));
        if (r.payDeadline) {
          // Крайният срок е с последици „или-или" — затова е откроен, не
          // е поредната сива бележка.
          out331.appendChild(warnLine('Плащане най-късно до ' + bgDate(r.payDeadline) +
            ' — иначе основанието по чл. 331 ОТПАДА (ал. 3).'));
        }
        noteList(out331, r.notes);
      } else {
        hint(out331, 'Въведете последното месечно БТВ, за да се сметне обезщетението (минимум 4 заплати).');
      }
    } catch (e) {
      out331.appendChild(warnLine('Проверете входа: ' + e.message));
    }
  }

  [servedI, unitSel, countI, contractEndI, todayI, baseI, baseMonthSel, baseYearI,
    nUnitSel, nCountI, alSel, kindSel, c221UnitSel, c221CountI, c221TermI,
    c221ContractEndI, c221DaysI, lastGrossI, multI, termI331]
    .forEach((n) => { n.addEventListener('input', recompute); n.addEventListener('change', recompute); });

  const panel = el('div', { class: 'panel calc-panel calc-notice' },
    el('h3', { class: 'calc-title', text: 'Предизвестие и прекратяване (чл. 326, 220, 221, 331 КТ)' }),
    el('div', { class: 'calc-fields' },
      row(hintify(field('Месечна база (чл. 228, ал. 1), €', baseI, { size: 's' }),
        'чл. 228, ал. 1 КТ', 'Базата е полученото БТВ за месеца, предхождащ месеца на основанието, или последното получено месечно БТВ.'),
        field('Месец на базата', baseMonthSel, { size: 's' }),
        field('Година на базата', baseYearI, { size: 's' })),
      el('div', { class: 'calc-note', text: 'Базата е полученото брутно възнаграждение за месеца, предхождащ основанието — ползва се от чл. 220 и чл. 221. Чл. 331 има отделно поле („последно ПОЛУЧЕНО месечно БТВ").' })),

    el('details', { open: true },
      el('summary', { text: 'Срок и дати на предизвестието (чл. 326 и чл. 335)' }),
      row(field('Връчено на', servedI, { size: 's' }),
        field('Срок — мярка', unitSel, { size: 'm' }),
        field('Срок — брой', countI, { size: 's' })),
      row(field('Краен срок на договора (само при срочен)', contractEndI, { size: 's' }),
        field('Днес (за оставащите дни)', todayI, { size: 's' })),
      outPeriod),

    el('details', {},
      el('summary', { text: 'Цена на неспазено предизвестие (чл. 220)' }),
      row(field('Неспазена част — мярка', nUnitSel, { size: 'm' }),
        field('Неспазена част — брой', nCountI, { size: 's' })),
      out220),

    el('details', {},
      el('summary', { text: 'Обезщетение по чл. 221' }),
      field('Основание', alSel),
      field('Вид договор', kindSel),
      boxIndef,
      boxFixed,
      out221),

    el('details', {},
      el('summary', { text: 'Прекратяване срещу обезщетение (чл. 331)' }),
      row(field('Последно месечно БТВ (чл. 331), €', lastGrossI, { size: 's' }),
        field('Уговорени заплати (минимум 4)', multI, { size: 's' }),
        field('Дата на прекратяване (чл. 331)', termI331, { size: 's' })),
      out331));

  recompute();
  return withLaw(panel, {
    when: [
      'Служител подава предизвестие — смятате кога изтича срокът и последния работен ден (чл. 326).',
      'Някоя от страните прекратява преди края на предизвестието — обезщетение за неспазения срок (чл. 220).',
      'Служителят напуска без предизвестие по чл. 327 (забавени заплати и др.) — работодателят дължи обезщетение (чл. 221, ал. 1).',
      'Работодателят предлага прекратяване срещу обезщетение — минимум четирикратното БТВ (чл. 331), с 1-месечен срок за плащане.',
    ],
    quotes: [
      { ref: 'чл. 326, ал. 2 КТ (доп. ДВ, бр. 108/2008)', text: 'Срокът на предизвестието при прекратяване на безсрочен трудов договор е 30 дни, доколкото страните не са уговорили по-дълъг срок, но не повече от 3 месеца. … Срокът на предизвестието при прекратяване на срочен трудов договор е 3 месеца, но не повече от остатъка от срока на договора.' },
      { ref: 'чл. 220, ал. 1 КТ', text: 'Страната, която има право да прекрати трудовото правоотношение с предизвестие, може да го прекрати и преди да изтече срокът на предизвестието, при което дължи на другата страна обезщетение в размер на брутното трудово възнаграждение на работника или служителя за неспазения срок на предизвестието.' },
      { ref: 'чл. 221, ал. 1 КТ (доп. ДВ, бр. 58/2010)', text: 'При прекратяване на трудовото правоотношение от работника или служителя без предизвестие в случаите по чл. 327, ал. 1, т. 2, 3 и 3а работодателят му дължи обезщетение в размер на брутното трудово възнаграждение за срока на предизвестието – при безсрочно трудово правоотношение, и в размер на действителните вреди – при срочно трудово правоотношение.' },
      { ref: 'чл. 331, ал. 1 – 3 КТ (нов — ДВ, бр. 25/2001)', text: 'Работодателят може да предложи по своя инициатива на работника или служителя прекратяване на трудовия договор срещу обезщетение. … Ако работникът или служителят приеме предложението по ал. 1, работодателят му дължи обезщетение в размер на не по-малко от четирикратния размер на последното получено месечно брутно трудово възнаграждение… Ако обезщетението по ал. 2 не бъде платено в едномесечен срок от датата на прекратяване на трудовия договор, основанието за неговото прекратяване се смята за отпаднало.' },
    ],
  });
}
